import { VxSwal } from '@voxie/frontend-components';
import { escapeHtml } from '~/utils/html';
import { stringifyQueryString } from '~/utils/string';

export const isLargeTeam = (teamId) => {
    // see app/Team.php
    const largeTeamMap = {
        100404: true, // Victra Wireless
        100818: true, // Edible Arrangements
        100823: true, // D.P. Dough
        100978: true, // PJ's Coffee
        101824: true, // Eargo - Marketing
        102472: true, // Jersey Mike's
        103150: true, // Inspire Brands - Sonic
        103266: true, // Urban Air
        103342: true, // Inspire Brands - Arby's
        103689: true, // Dunkin'
    };

    return Boolean(largeTeamMap[teamId]);
};

export const isLargeTeamSearchRestricted = (teamId, groupId) => {
    if (groupId || Spark.state.currentGroup?.group_id || Spark.state.currentOrgUnit?.id) {
        return false;
    }

    return isLargeTeam(teamId);
};

export const isHeightsWellnessTeam = (teamId) => teamId === 103601; // Heights Wellness — Resource Center link
export const isDucklingsTeam = (teamId) => teamId === 103587; // Ducklings Early Learning Center — Resource Center link
export const isOptimizeUTeam = (teamId) => teamId === 103642; // Optimize U — Resource Center link
export const isStratusCleanTeam = (teamId) => teamId === 103617; // Stratus Clean — Resource Center link
export const isThePicklrTeam = (teamId) => teamId === 103589; // The Picklr — Resource Center link
export const isRedlineGearCleaningTeam = (teamId) => teamId === 103599; // Redline Gear Cleaning — franchisee training video link

// TLE parent teams: hide the Company Legal Name billing field on their child teams' billing pages
export const isCompanyLegalNameHidden = (parentTeamId) => [101802, 103620, 103619].includes(parentTeamId);

export const isNotActive = () => {
    return Spark.state.currentTeam.status !== 'active';
};

// link=1 binds the IdP identity to the signed-in account; the ACS refuses account_mismatch otherwise
export const switchTeamHref = (team) => {
    const href = `/settings/teams/${team.id}/switch`;

    if (!team.locked || !team.sso_login_url) {
        return href;
    }

    return `${team.sso_login_url}?${stringifyQueryString({ link: 1, intended: href })}`;
};

export const formatTeamStatus = (status) => {
    if (status === 'pending') {
        return 'Draft';
    }
    return status ? status.charAt(0).toUpperCase() + status.slice(1) : '';
};

export const displayNotActiveModal = () => {
    const team = Spark.state.currentTeam;

    if (team.status === 'suspended') {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            icon: 'error',
            confirmButtonColor: 'danger',
            title: 'This Voxie Account is Suspended',
            html: `Sorry for the inconvenience, we know how important having access to your Voxie account is. Unfortunately, this account has been suspended by our Team${
                team.status_reason ? ', due to ' + escapeHtml(team.status_reason).replace(/\r?\n/g, '<br />') : '.'
            }
                <br />
                <br />
                Please contact your Account Administrator to rectify the account situation and restore your access immediately.`,
        });
    } else if (team.status === 'closed') {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            icon: 'info',
            title: 'This Voxie Account is Closed',
            html: `Please contact your Account Administrator to discuss the creation of a new account.`,
        });
    } else {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            title: 'Your Voxie Account is Awaiting Activation',
            html: `Welcome to Voxie! We're in the process of validating your subscription. Until then, your ability to send texts
                is disabled. Hang tight, you should have access shortly. For any questions please contact your account representative
                or <a href="mailto:support@voxie.com">support@voxie.com</a>.`,
        });
    }
};
